import React, { useState, useEffect } from 'react';

import FormModal from 'components/Modals/formModal';
import { passwordRegex } from 'constants/regex';
import { passwordHasKeyword } from 'functions/stringValidation';
import { InfoText } from 'components/FormComponents/FormComponents';
import { ErrorMessage, TextInput, InstructionContainer, InstructionsHeading } from './styles';

export default React.memo(({ user, onCancel, onConfirm, resetPasswordViaEmail }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validPassword, setValidPassword] = useState(false);
  const [invalidKeywordsUsed, setInvalidKeywordUsed] = useState(false);

  useEffect(() => {
    setValidPassword(passwordRegex.test(newPassword));
    setInvalidKeywordUsed(passwordHasKeyword(newPassword, user.email, user.name, user?.coderCommunityProfile?.name));
  }, [newPassword, user]);

  return (
    <FormModal
      title="Set Password"
      confirmButtonText="Save Password"
      onCancel={onCancel}
      onConfirm={() => onConfirm({ oldPassword, newPassword })}
      disabled={
        !oldPassword ||
        !newPassword ||
        !confirmPassword ||
        !validPassword ||
        newPassword !== confirmPassword ||
        invalidKeywordsUsed
      }
      additionalActionButton={[{ text: 'Reset password via email', onClick: () => resetPasswordViaEmail() }]}
    >
      <InstructionsHeading>Note: You can not reuse one of your previous 10 passwords.</InstructionsHeading>
      <TextInput
        value={oldPassword}
        isEditing={true}
        placeholder="Old Password"
        type="password"
        onChange={(e) => {
          setOldPassword(e.target.value);
        }}
      />
      <TextInput
        value={newPassword}
        isEditing={true}
        placeholder="New Password"
        type="password"
        onChange={(e) => {
          setNewPassword(e.target.value);
        }}
      />
      <TextInput
        value={confirmPassword}
        isEditing={true}
        placeholder="Confirm Password"
        type="password"
        onChange={(e) => {
          setConfirmPassword(e.target.value);
        }}
      />
      {newPassword !== confirmPassword && (
        <ErrorMessage padding="5px 0" noMargin>
          Passwords don't match
        </ErrorMessage>
      )}
      <InstructionContainer>
        <InstructionsHeading hasTopMargin>Instructions:</InstructionsHeading>
        <InfoText success={validPassword ? true : false}>
          1. Password must be at least 10 characters long, contain a lowercase letter, one uppercase letter, and one
          digit.
        </InfoText>
        <InfoText
          error={invalidKeywordsUsed ? true : false}
          success={invalidKeywordsUsed || !newPassword.length ? false : true}
        >
          2. Your Name and E-mail (username and domain of username@domain.com) should not be part of the password.
        </InfoText>
      </InstructionContainer>
    </FormModal>
  );
});
